import React from "react";
import { Box, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { useUser } from "../../../hook/useUser.js";

const RoleBaseActionButtons = ({ reportStatus, allDailyReportSubmitted, setState, reportReadOnly }) => {
  // reportStatus
  // 1: "In preparation" - user and pm both can save edit
  // 2: "Awaiting PM approval" -pm can save edit
  // 3: "Finalized (Contractor Approved)"
  // 4: "Finalized (CLP Approved)"
  // 5: "Late"
  //reportReadOnly-userRole是CLP User时要用这个判断
  //true 只读
  //false 可编辑
  const { projectId } = useParams();
  const { user } = useUser(projectId);
  const userRole = () => {
    const roleMapping = {
      "CLP User": reportReadOnly === true ? "CLP_readonly" : user?.isPM ? "CLP_PM" : "CLP_user",
      // "CLP User": user?.isPM ? "CLP_PM" : "CLP_user",
      Contractor: user?.isPM ? "Contractor_PM" : "Contractor_user",
      "System Administrator": "CLP_PM",
      "Executive User": "CLP_PM",
    };
    return roleMapping[user?.userRole] || "unknown";
  };
  const getButton = () => {
    const role = userRole();
    const statusToButtonTypeMap = {
      Contractor_user: {
        1: { type: "Contractor_user_1", comment: "(1)save edit (2)complete" }, // reportStatus is 1
        5: { type: "Contractor_user_1", comment: "(1)save edit (2)complete" }, // reportStatus is 5
        2: {
          type: "Contractor_user_2",
          comment: "(1) disabled save edit (2) retract report",
        }, // reportStatus is 2
        3: {
          type: "Contractor_user_2",
          comment: "(1) disabled save edit (2) retract report",
        }, // reportStatus is 3
        4: {
          type: "Contractor_user_2",
          comment: "(1) disabled save edit (2) retract report",
        }, // reportStatus is 4
      },
      Contractor_PM: {
        1: {
          type: "Contractor_PM_1",
          comment: "(1)save edit (2)submit report (3)disabled reject report",
        }, // reportStatus is 1
        5: {
          type: "Contractor_PM_1",
          comment: "(1)save edit (2)submit report (3)disabled reject report",
        }, // reportStatus is 5
        2: {
          type: "Contractor_PM_2",
          comment: "(1)save edit (2)submit report (3)reject report",
        }, // reportStatus is 2
        3: {
          type: "Contractor_PM_3",
          comment: "(1)disabled save edit (2)disabled submit report (3)retract report",
        }, // reportStatus is 3
        4: {
          type: "Contractor_PM_2",
          comment: "(1)disabled save edit (2)submit report (3)retract report",
        }, // reportStatus is 4
      },
      CLP_user: {
        1: { type: "CLP_user_1", comment: "(1)save edit (2)complete" }, // reportStatus is 1
        5: { type: "CLP_user_1", comment: "(1)save edit (2)complete" }, // reportStatus is 5
        2: {
          type: "CLP_user_2",
          comment: "(1)disabled save edit (2)retract report",
        }, // reportStatus is 2
        3: {
          type: "CLP_user_2",
          comment: "(1)disabled save edit (2)retract report",
        }, // reportStatus is 3
        4: {
          type: "CLP_user_2",
          comment: "(1)disabled save edit (2)retract report",
        }, // reportStatus is 4
      },
      CLP_PM: {
        1: {
          type: "CLP_PM_1",
          comment: "(1)save edit (2)submit report (3)disabled reject report",
        }, // reportStatus is 1
        5: {
          type: "CLP_PM_1",
          comment: "(1)save edit (2)submit report (3)disabled reject report",
        }, // reportStatus is 5
        2: {
          type: "CLP_PM_2",
          comment: "(1)save edit (2)submit report (3)reject report",
        }, // reportStatus is 2
        3: {
          type: "CLP_PM_2",
          comment: "(1)save edit (2)submit report (3)reject report",
        }, // reportStatus is 3
        4: {
          type: "CLP_PM_3",
          comment: "(1)disabled save edit (2)disabled submit report (3)retract report",
        }, // reportStatus is 4
      },
      CLP_readonly: {
        1: {
          type: "CLP_readonly_1",
          comment: "disabled reject report",
        }, // reportStatus is 1
        5: {
          type: "CLP_readonly_1",
          comment: "disabled reject report",
        }, // reportStatus is 5
        2: {
          type: "CLP_readonly_1",
          comment: "disabled reject report",
        }, // reportStatus is 2
        3: {
          type: "CLP_readonly_2",
          comment: "reject report",
        }, // reportStatus is 3
        4: {
          type: "CLP_readonly_1",
          comment: "disabled reject report",
        }, // reportStatus is 4
      },
    };

    const buttonType = statusToButtonTypeMap[role]?.[reportStatus];
    return buttonType?.type || null;
  };

  const buttonsConfig = {
    Contractor_user_1: [
      {
        text: "Save Edit",
        color: "secondary",
        iconSrc: "assets/buttons/saveedit.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "saveEditReport",
            confirmPopupText: "Confirm to save edit this report?",
            confirmPopupTitle: "Confirm Save Edit",
          })),
      },
      {
        text: "Complete",
        color: "success",
        iconSrc: "assets/buttons/ok.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "completeReport",
            confirmPopupText: "Confirm to complete this report?",
            confirmPopupTitle: "Confirm Complete Report",
          })),
      },
    ],
    Contractor_user_2: [
      {
        text: "Save Edit",
        color: "secondary",
        iconSrc: "assets/buttons/saveedit.svg",
        disabled: true,
      },
      {
        text: "Retract Report",
        color: "error",
        iconSrc: "assets/buttons/retract.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "retractReport",
            confirmPopupText: "Confirm to retract this report?",
            confirmPopupTitle: "Confirm Retract Report",
          })),
      },
    ],
    Contractor_PM_1: [
      {
        text: "Save Edit",
        color: "secondary",
        iconSrc: "assets/buttons/saveedit.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "saveEditReport",
            confirmPopupText: "Confirm to save edit this report?",
            confirmPopupTitle: "Confirm Save Edit",
          })),
      },
      {
        text: "Submit Report",
        color: "success",
        iconSrc: "assets/buttons/ok.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "submitReport",
            confirmPopupText: "Please confirm the report content are finalized before submitting report.",
            confirmPopupTitle: "Confirm Submit Report",
          })),
      },
      {
        text: "Reject Report",
        color: "error",
        iconSrc: "assets/buttons/reject.svg",
        disabled: true,
      },
    ],
    Contractor_PM_2: [
      {
        text: "Save Edit",
        color: "secondary",
        iconSrc: "assets/buttons/saveedit.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "saveEditReport",
            confirmPopupText: "Confirm to save edit this report?",
            confirmPopupTitle: "Confirm Save Edit",
          })),
      },
      {
        text: "Submit Report",
        color: "success",
        iconSrc: "assets/buttons/ok.svg",
        disabled: allDailyReportSubmitted === false,
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "submitReport",
            confirmPopupText: "Please confirm the report content are finalized before submitting report.",
            confirmPopupTitle: "Confirm Submit Report",
          })),
      },
      {
        text: "Reject Report",
        color: "error",
        iconSrc: "assets/buttons/reject.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            rejectPopup: true,
          })),
      },
    ],
    Contractor_PM_3: [
      {
        text: "Save Edit",
        color: "secondary",
        iconSrc: "assets/buttons/saveedit.svg",
        disabled: true,
      },
      {
        text: "Submit Report",
        color: "success",
        iconSrc: "assets/buttons/ok.svg",
        disabled: true,
      },
      {
        text: "Retract Report",
        color: "error",
        iconSrc: "assets/buttons/retract.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            retractPopup: true,
          })),
      },
    ],
    CLP_user_1: [
      {
        text: "Save Edit",
        color: "secondary",
        iconSrc: "assets/buttons/saveedit.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "saveEditReport",
            confirmPopupText: "Confirm to save edit this report?",
            confirmPopupTitle: "Confirm Save Edit",
          })),
      },
      {
        text: "Complete",
        color: "success",
        iconSrc: "assets/buttons/ok.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "completeReport",
            confirmPopupText: "Confirm to complete this report?",
            confirmPopupTitle: "Confirm Complete Report",
          })),
      },
    ],
    CLP_user_2: [
      {
        text: "Save Edit",
        color: "secondary",
        iconSrc: "assets/buttons/saveedit.svg",
        disabled: true,
      },
      {
        text: "Retract Report",
        color: "error",
        iconSrc: "assets/buttons/retract.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "retractReport",
            confirmPopupText: "Confirm to retract this report?",
            confirmPopupTitle: "Confirm Retract Report",
          })),
      },
    ],
    CLP_PM_1: [
      {
        text: "Save Edit",
        color: "secondary",
        iconSrc: "assets/buttons/saveedit.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "saveEditReport",
            confirmPopupText: "Confirm to save edit this report?",
            confirmPopupTitle: "Confirm Save Edit",
          })),
      },
      {
        text: "Submit Report",
        color: "success",
        iconSrc: "assets/buttons/ok.svg",
        disabled: allDailyReportSubmitted === false,
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "submitReport",
            confirmPopupText: "Please confirm the report content are finalized before submitting report.",
            confirmPopupTitle: "Confirm Submit Report",
          })),
      },
      {
        text: "Reject Report",
        color: "error",
        iconSrc: "assets/buttons/reject.svg",
        disabled: true,
      },
    ],
    CLP_PM_2: [
      {
        text: "Save Edit",
        color: "secondary",
        iconSrc: "assets/buttons/saveedit.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "saveEditReport",
            confirmPopupText: "Confirm to save edit this report?",
            confirmPopupTitle: "Confirm Save Edit",
          })),
      },
      {
        text: "Submit Report",
        color: "success",
        iconSrc: "assets/buttons/ok.svg",
        disabled: allDailyReportSubmitted === false,
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            isConfirming: true,
            actionType: "submitReport",
            confirmPopupText: "Please confirm the report content are finalized before submitting report.",
            confirmPopupTitle: "Confirm Submit Report",
          })),
      },
      {
        text: "Reject Report",
        color: "error",
        iconSrc: "assets/buttons/reject.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            rejectPopup: true,
          })),
      },
    ],
    CLP_PM_3: [
      {
        text: "Save Edit",
        color: "secondary",
        iconSrc: "assets/buttons/saveedit.svg",
        disabled: true,
      },
      {
        text: "Submit Report",
        color: "success",
        iconSrc: "assets/buttons/ok.svg",
        disabled: true,
      },
      {
        text: "Retract Report",
        color: "error",
        iconSrc: "assets/buttons/retract.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            retractPopup: true,
          })),
      },
    ],
    CLP_readonly_1: [
      {
        text: "Reject Report",
        color: "error",
        iconSrc: "assets/buttons/reject.svg",
        disabled: true,
      },
    ],
    CLP_readonly_2: [
      {
        text: "Reject Report",
        color: "error",
        iconSrc: "assets/buttons/reject.svg",
        onClick: () =>
          setState((prevState) => ({
            ...prevState,
            rejectPopup: true,
          })),
      },
    ],
  };

  const getIconSrc = (iconSrc, disabled) => {
    if (disabled && typeof iconSrc === "string") {
      return iconSrc.replace(/\.svg$/, "-disabled.svg");
    }
    return iconSrc;
  };

  const buttonSx = (color, disabled) => ({
    pr: 2,
    pl: 1,
    py: 0,
    lineHeight: "28px",
    borderRadius: "20px",
    ...(disabled && {
      backgroundColor: "#D0D5DE!important",
      pointerEvents: "none",
    }),
    ...(color && { color }),
  });

  const buttons = buttonsConfig[getButton()] || [];

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mr: 4 }}>
      {buttons.map((button, index) => (
        <Button
          key={index}
          variant="contained"
          color={button.color}
          onClick={button.disabled ? undefined : button.onClick}
          disabled={button.disabled || false}
          sx={buttonSx(button.color, button.disabled)}
          startIcon={<img src={getIconSrc(button.iconSrc, button.disabled)} alt={`${button.text} Icon`} />}
        >
          {button.text}
        </Button>
      ))}
    </Box>
  );
};

export default RoleBaseActionButtons;
